export default __webpack_public_path__ + "static/media/vercel.f57de0a9.svg";